import apiRequest from "../../helpers/apiRequest";

export default async (id, formData) => {
    return await apiRequest({
        method: 'patch',
        url: `content/update/note/${id}/`,
        data: formData
    })
}
